import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { UserDetail } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class WindowsService {
  IMPERSONATION_STORAGE_KEY = 'impersonatedUserId';

  private readonly isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  alert(message: string): void {
    if (this.isBrowser) {
      window.alert(message);
    }
  }

  confirm(message: string): boolean {
    if (this.isBrowser) {
      return window.confirm(message);
    }
    return false;
  }

  setToLocalStorage(key: string, value: string): void {
    if (this.isBrowser) {
      localStorage.setItem(key, value);
    }
  }

  getFromLocalStorage(key: string): string | null {
    if (this.isBrowser) {
      return localStorage.getItem(key);
    }
    return null;
  }

  removeFromLocalStorage(key: string): void {
    if (this.isBrowser) {
      localStorage.removeItem(key);
    }
  }

  clearLocalStorage(): void {
    if (this.isBrowser) {
      localStorage.clear();
    }
  }

  setToSessionStorage(key: string, value: string): void {
    if (this.isBrowser) {
      sessionStorage.setItem(key, value);
    }
  }

  getFromSessionStorage(key: string): string | null {
    if (this.isBrowser) {
      return sessionStorage.getItem(key);
    }
    return null;
  }

  removeFromSessionStorage(key: string): void {
    if (this.isBrowser) {
      sessionStorage.removeItem(key);
    }
  }

  clearSessionStorage(): void {
    if (this.isBrowser) {
      sessionStorage.clear();
    }
  }

  generateLoginSourceKey(portal: string) {
    return `${portal}_${this.IMPERSONATION_STORAGE_KEY}`;
  }

  setImpersonatingUser(user: UserDetail | null, portal) {
    this.setToLocalStorage(
      this.generateLoginSourceKey(portal),
      JSON.stringify(user)
    );
  }

  getImpersonatingUser(portal) {
    return JSON.parse(
      this.getFromLocalStorage(this.generateLoginSourceKey(portal))
    );
  }

  isImpersonating(portal) {
    return this.getImpersonatingUser(portal) ? true : false;
  }

  resetImpersonation(portal) {
    this.removeFromSessionStorage(this.generateLoginSourceKey(portal));
  }
}
